import {
  ADD_ALERT,
  CLEAR_ALERT,
  ADD_ATHLETE,
  REMOVE_ATHLETE,
  UPDATE_FRIENDS,
  UPDATE_FRIEND_FOLLOWING_STATUS
} from './friendsActions';

export const reducer = (state, action) => {
  switch (action.type) {
    case ADD_ALERT: {
      const { alert } = action.payload;
      return {
        ...state,
        alert
      };
    }
    case CLEAR_ALERT: {
      return {
        ...state,
        alert: null
      };
    }
    case ADD_ATHLETE: {
      const { friend } = action.payload;
      return {
        ...state,
        followedFriends: {
          ...state.followedFriends,
          [friend.id]: friend
        }
      };
    }
    case REMOVE_ATHLETE: {
      const { id } = action.payload;
      const { [id]: _, ...rest } = state.followedFriends;
      return {
        ...state,
        followedFriends: { ...rest }
      };
    }
    case UPDATE_FRIENDS: {
      const { friends } = action.payload;
      return {
        ...state,
        friends
      };
    }
    case UPDATE_FRIEND_FOLLOWING_STATUS: {
      const { id, isFollowable, followingStatus } = action.payload;
      const friend = state.friends[id];
      return {
        ...state,
        friends: {
          ...state.friends,
          [id]: { ...friend, isFollowable, followingStatus }
        }
      };
    }
    default:
      throw new Error(`${action.type} not recognized`);
  }
};

export default { reducer };
